import React from 'react';
const AgentDetails = () => (
  <> 
 <div id="kt_body" class="">
    <div class="d-flex flex-column flex-root">			
           <div className='container'>
  <div className='col-md-12 col-lg-12'>
    <div className='box_shadow mt-5'>
      <div class="row">
        <h1 className='headings'>Welcome to Our Board</h1>
					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="required">Organization Name</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder="." id="" />
						</div>
					</div>
					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="required">Organization Code</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder="." id="" />
						</div>
					</div>
					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Assign IATA Group</label>
							<select class="form-select form-select-solid">
								<option defaultValue="">Trans India Technologiess</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Coorporate Accounts Code</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder="." id="" />
						</div>
					</div>
					
					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Business Email ID</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder="." id="" />
						</div>
					</div>
					
					<div class="col-md-12 mb-3">
						<div class="form-group">
							<label class="">Registered Address </label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder="." id="" />
						</div>
					</div>
					
					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Country</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder="." id="" />
						</div>
					</div>
					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">State</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder="." id="" />
						</div>
					</div>
					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">City</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder="." id="" />
						</div>
					</div>

					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Postal Code</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder="." id="" />
						</div>
					</div>

					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Account Type</label>
							<select class="form-select form-select-solid">
								<option defaultValue="">Select Account Type...</option>
								<option value="1">Business</option>
								<option value="2">Savings</option>
							</select>
						</div>
					</div>

					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Integration Ref. Number</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder="." id="" />
						</div>
					</div>
					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Customer Base Currency</label>
							<select class="form-select form-select-solid">
								<option defaultValue="">INR</option>
								<option value="1">Euro</option>
								<option value="2">Doller</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="required">Customer Base Country</label>
							<select class="form-select form-select-solid">
								<option defaultValue="">India</option>
								<option value="1">Australia</option>
							</select>
						</div>
					</div>

					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Travel Desk Email</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder=".." id="" />
						</div>
					</div>

					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Account Activation Date</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder=".." id="" />
						</div>
					</div>

					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Account De-activation Date</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder=".." id="" />
						</div>
					</div>
					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">GST on Management Fee</label>
							<select class="form-select form-select-solid">
								<option defaultValue="">Yes</option>
								<option value="1">No</option>
							</select>
						</div>
					</div>
					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Pass GST Details to the Airline</label>
							<select class="form-select form-select-solid">
								<option defaultValue="">Yes</option>
								<option value="1">No</option>
							</select>
						</div>
					</div>
					<div class="col-md-12 mt-5 mb-5">
						<div class="form-check form-check-inline">
							<input class="form-check-input" id="Active" name="Status" type="radio" value="1" />
							<label class="form-check-label clr" for="Active">Create new GDS profile</label>
						</div>
						<div class="form-check form-check-inline">
							<input class="form-check-input" id="Inactive" name="Status" type="radio" value="0" />
							<label class="form-check-label clr" for="Inactive">Update existing customer profile</label>
						</div>
					</div>
					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Business</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder=".." id="" />
						</div>
					</div>


					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">GAL Profile PNR</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder=".." id="" />
						</div>
					</div>


					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">AMD Profile PNR</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder=".." id="" />
						</div>
					</div>


					<div class="col-md-3 mb-3">
						<div class="form-group">
							<label class="">Sabre Profile PNR</label>
							<input class="form-control form-control-solid" name="" type="text" defaultValue="" placeholder=".." id="" />
						</div>
					</div>
          <div class="col-md-6 mt-3 mb-3">
          <p className='Already'>Already have an account? <a href='/login'> Sign in</a></p>
          </div>
					<div class="col-md-6 mb-3 text-end">
                        <a href='/Dashboard' className='btn btn-primary mt-3'>Create Organization</a>
						{/* <button type="button" class="btn btn-primary mt-3" id="btnSearch">Create Organization</button> */}
					</div>

				</div>
     </div>
    </div>
  </div>
        </div>
        </div>


  </>
   
);

export default AgentDetails;
